<template>
  <div>
    <div class="header profile" />
    <div
      v-if="loaded"
      class="container"
    >
      <div class="profile-header">
        <h1 class="title is-1 text color-white">
          {{ collection.name }}
        </h1>
        <h2 class="subtitle is-marginless text color-red">
          {{ collection.items.length }} tracks
        </h2>
      </div>
      <div class="box is-large">
        <p v-if="collection.description.length > 0">
          {{ collection.description }}
        </p>
        <br v-if="collection.description.length > 0">

        <div
          v-for="track in collection.items"
          :key="track.pk"
        >
          <track-list-item :track="track" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sharedCollectionsClient from '@/api/sharedCollections.js'
import TrackListItem from '@/components/TrackListItem.vue'

export default {
  name: 'SharedCollectionDetail',

  components: {
    TrackListItem
  },

  props: {
    privateCollectionId: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      collection: null,
      loaded: false,
      showDeleteCollectionModal: false,
      trackIdToRemove: null,
      showRemoveTrackModal: false
    }
  },

  created () {
    // Load this collection data.
    sharedCollectionsClient.retrieve(this.privateCollectionId)
      .then(response => {
        this.collection = response.data
        this.loaded = true
        if (this.collection.items.length > 0) {
          this.$store.dispatch('player/loadTracks', this.collection.items)
        }
      })
      .catch(error => {
        if (error.response.status === 404) {
          this.$router.push({ name: 'not-found' })
        }
      })
  },

  metaInfo () {
    if (this.collection) {
      const title = `${this.collection.name} | Music Licensing`

      return {
        title
      }
    } else {
      return {
        title: 'Music Licensing'
      }
    }
  }
}
</script>

<style>
</style>
